<template>
  <div class="xh-esg-page">
    <el-row class="xh-esg-content">
      <el-row>
        <el-col class="xh-esg-right" :span="24">
          <!-- <List :classifyCode="classifyCode"></List> -->
          <template  v-show="newsContent.News_title">
            <div class="title">{{ newsContent.News_title }}</div>
            <div class="detailInfo">
              <div class="detailInfoLeft">
                <div class="time">{{ newsContent.Issued_date }}</div>
                <div class="resource">来源: {{ newsContent.source }}</div>
              </div>
              <div
                class="detailInfoRight"
                @click="downFile(newsContent.AttachUrl)"
                v-if="$filters.empty(newsContent.AttachUrl)"
              >
                <i class="downloadIcon"></i>下载附件
              </div>
            </div>
            <div class="content" v-html="newsContent.Data_content"></div>
          </template>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
/* import List from "./components/List"; */

export default {
  data() {
    return {
      /* classifyCode:"", */
      newsContent: {},
    };
  },
  components: {
    /* List */
  },
  computed: {},
  mounted() {
    let newsid = this.$route.query.newsId;
    console.log(newsid);
    this.getNewsContent({ newsid: newsid }).then((data) => {
      let item = data.data[0];
      if(item){
        item.Data_content = this.updateContentStyle(item.Data_content);
        this.newsContent = item;
      }
    });
  },
  methods: {
    ...mapActions("dynamicInfo/index", {
      getNewsContent: "GET_NEWS_CONTENT",
    }),
    downFile(url) {
      this.$utils.downloadfile(url);
    },
    updateContentStyle(content = ""){
      // content = content.replace("background-color: #FFFFFF;'","background-color: rgba(45,67,71,0.3)    '")
      content = content.replace(/(([\s;]|'|")+)((background-color|background|color)[\s:]*(#|rgb|rgba|hsl|hsla)[a-fA-F0-9,()\s\\.]*[\s;]{0,2})('|")?/gi, "$1/*replace style $3*/$6");
      content = content.replace(/(([\s;]|'|")+)((background-color|background|color)[\s:]*(AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGray|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGray|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGray|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gray|Green|GreenYellow|HoneyDew|HotPink|IndianRed |Indigo |Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGray|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGray|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGray|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)[\s;]{0,2})('|")?/gi, "$1/*replace style $3*/$6");
      return content;
    }
  },
  
};
</script>
<style lang="scss" scoped>
.xh-esg-page {
  .xh-esg-content {
    max-width: 1020px;
    margin: auto;
    margin-top: 30px;
    background-color: var(--comp_06);
    .xh-esg-right {
      padding: 30px 110px;
      min-height: 520px;
      .title {
        font-size: 24px;
        font-weight: 500;
        color: var(--font_01);
        line-height: 33px;
        margin-bottom: 8px;
      }
      .detailInfo {
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
        .detailInfoLeft {
          display: flex;
          .time {
            margin-right: 20px;
            color: #a1a7af;
          }
          .resource {
            color: #a1a7af;
          }
        }
        .detailInfoRight {
          cursor: pointer;
          color: var(--font_01);
          .downloadIcon {
            display: inline-block;
            width: 14px;
            height: 14px;
            margin-right: 10px;
            background: url("../../assets/white_theme/download.png") no-repeat;
            background-position: center;
            background-size: cover;
          }
        }
      }
      .content {
        font-size: 14px;
        font-weight: 400;
        color: var(--font_01);
        line-height: 22px;
        /deep/ img{
          width: 800px;
        }
      }
    }
  }
}
</style>
